'use strict';

$.fn.scrollTo = function(duration = 2000, offset = 0, $element = $('html, body')) {
    let $target = $(this);

    if ($target.length === 0) {
        return;
    }

    return $element.animate({
        scrollTop: $target.offset().top + offset
    }, duration);
};



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/jquery.scrollTo.js